import { render } from "./AcademicHome.vue?vue&type=template&id=3393a1da"
import script from "./AcademicHome.vue?vue&type=script&lang=js"
export * from "./AcademicHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__